<template>
	<AppDialog ref="dialog_container" dialogName="DeleteBlockDialog">
		<div class="delete-block-dialog">
			<div class="dialog-title flex-centerize text-align-center mt-4">
				Are you sure you want to<br />
				delete this step?
			</div>
			<div class="dialog-body">
				<div class="my-4 pt-1 overflow-hidden" style="pointer-events: none; transform: scale(0.85); transform-origin: center">
					<FlowTreeBlockDataProvider v-bind="{ blockData: block, disabled: true }" />
				</div>
			</div>
			<div class="dialog-bottom flex-centerize">
				<CancelButton class="mr-3" @click="cancel">Cancel</CancelButton>
				<DangerButton @click="deleteBlock" :loading="loading"> Delete </DangerButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import FlowTreeBlockDataProvider from '@/components/FlowTree/FlowTreeBlock/FlowTreeBlockDataProvider';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import { deleteNode } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'DeleteBlockDialog',
	components: {
		AppDialog,
		FlowTreeBlockDataProvider,
	},
	props: {
		block: { type: Object, required: true },
	},
	methods: {
		...mapActionsShorthand({ deleteNode }),
		close() {
			this.$refs.dialog_container.closeCurrentDialog();
		},
		cancel() {
			this.close();
		},
		async deleteBlock() {
			this.loading = true;
			try {
				const ret = await this.deleteNode({ id: this.block.id });
				if (ret?.error) {
					this.$toast.error(`Failed to delete step, please try again`);
				} else {
					this.close();
				}
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return { loading: false };
	},
};
</script>

<style scoped lang="scss">
.delete-block-dialog {
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}
}
</style>
